export default function createDataLoaders(api, httpClient, locale) {
  const fetchProducts = async (productIds) => {
    try {
      const params = {
        search: `id:${productIds.map((id) => `${id}`).join(',')}`,
        searchFields: 'id:in',
        limit: 0,
        lang: locale.value,
      };
      const { data } = await api.productService.getAllProducts(params);
      return data || [];
    } catch (error) {
      console.error('Error fetching products:', error);
      return [];
    }
  };

  const fetchPromotion = async (promoId) => {
    try {
      const { data } = await httpClient(`/api/promotions/${promoId}`);
      return data || [];
    } catch (error) {
      console.error('Error fetching promotion:', error);
      return [];
    }
  };

  const fetchInstagramPosts = async (limit) => {
    try {
      const { data } = await httpClient('/api/social/posts', {
        query: {
          network: 'instagram',
          ...(limit && { limit: String(limit) }),
        },
      });
      return data || [];
    } catch (error) {
      console.error('Error fetching instagram posts:', error);
      return [];
    }
  };

  const fetchPages = async (tagId, lang = 'en') => {
    try {
      // `tag_ids` stays an array: $httpClient serializes it axios-style
      // (`tag_ids[]=1`), which is what the CMS expects
      const data = await httpClient('/api/pages/list', {
        query: { type: 'page', tag_ids: [tagId], lang },
      });
      return data?.data ?? [];
    } catch (error) {
      console.error('Error fetching pages:', error);
      return [];
    }
  };

  return {
    fetchProducts,
    fetchPromotion,
    fetchInstagramPosts,
    fetchPages,
  };
}
